/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { FunctionComponent, VNode } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { VComponent, classes } from '@adobe-commerce/elsie/lib';
import '@/cart/components/CartSummaryGrid/CartSummaryGrid.css';
export interface CartSummaryGridProps extends HTMLAttributes<HTMLDivElement> {
  products?: VNode | null;
  emptyCart: VNode;
}

export const CartSummaryGrid: FunctionComponent<CartSummaryGridProps> = ({
  className,
  children,
  emptyCart,
  products,
  ...props
}) => {
  return (
    <div {...props} className={classes(['cart-cart-summary-grid', className])}>
      <>
        <div
          className={classes([
            'cart-cart-summary-grid__content',
            ['cart-cart-summary-grid__content--empty', !products],
          ])}
        >
          {products || (
            <VComponent
              node={emptyCart}
              className="cart-cart-summary-grid__empty-cart"
            />
          )}
        </div>
      </>
    </div>
  );
};
